export enum MessageSendCondition {
  OnPurchase = 'Al comprar un curso',
  OnCourseCompletion = 'Al finalizar un curso',
  OnUserInactivity = 'Inactividad de un usuario en un curso',
  OnFlashCourseDeadlineWarning = 'Advertencia de fin de plazo de un curso flash',
  OnCourseClassCompletion = 'Hito al finalizar una clase',
}
